var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"txt-loading"},[_vm._v("数据加载中…")])}
var staticRenderFns = []

export { render, staticRenderFns }